import { render, staticRenderFns } from "./cart-list.vue?vue&type=template&id=197b3ba0&"
import script from "./cart-list.vue?vue&type=script&lang=js&"
export * from "./cart-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports